import { Link } from "react-router-dom";
import img from "../../../images/photographer.jpg";
export default function Banner() {
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(to right bottom, rgba(0,0,0,0.1), rgba(245,158,11,.15)),url(${img})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
      }}
      className="min-h-[60vh] md:min-h-[83vh] rounded-md flex flex-col justify-center items-center text-white"
    >
      <div className="w-4/5 mx-auto">
        <h1 className="text-2xl font-semibold  sm:text-3xl md:text-4xl">
          Anytime, Anywhere. From any distance
          <span className="font-bold text-amber-500">...</span>
        </h1>
        <p className="mt-6 text-base font-semibold sm:text-lg sm:mt-3 lg:mt-8 lg:w-4/5 ">
          Photography is my passion. I try to do my best that's why my client's
          are satisfied what I do. Photgraphy is my satisfaction not my
          perfection.
        </p>
        <div className="flex gap-6 mt-10 text-base font-semibold sm:text-lg lg:mt-20">
          <Link
            to="/"
            className="flex items-center px-2 py-1 text-white duration-300 rounded-md shadow-sm cursor-pointer bg-amber-500 sm:px-4 sm:py-2 hover:bg-amber-600 active:bg-amber-700 transorm transtion active:translate-y-1 focus:ring-2 focus:ring-offset-4 focus:ring-amber-600 active:shadow-amber-300 active:shadow-sm backface-hidden"
          >
            Success Story
          </Link>
          <button className="px-2 py-1 border-4 rounded-md border-amber-500 sm:px-4 sm:py-2 ">
            Read More
          </button>
        </div>
      </div>
    </div>
  );
}
